import React, { FC } from "react";
import { CheckoutRowData } from "@containers/PayPerLead/interface";
import { ReactComponent as LeadsIcon } from "@assets/files/icons/general/user-shadow.svg";

import { Price } from "./Price";

export interface CheckoutRowProps {
  item: CheckoutRowData;
}

export const CheckoutRow: FC<CheckoutRowProps> = ({ item }) => {
  return (
    <div className="state-row">
      {item.subitems.map((subitem, index) => (
        <div key={index} className="county-row">
          <div className="label">{subitem.label}</div>
          <div className="summary">
            <div className="leads">
              <LeadsIcon />
              {subitem.leads} lead{subitem.leads > 1 ? "s" : ""}
            </div>

            <div className="amount">
              {subitem.perLead ? (
                <>
                  <Price amount={subitem.perLead} />
                  <span className="per-lead">/lead</span>
                </>
              ) : (
                <Price amount={subitem.price} />
              )}
            </div>
          </div>
        </div>
      ))}
      {item.subtotal.label && (
        <div className="subtotal">
          <div className="label">{item.subtotal.label}</div>
          <div className="amount">
            <Price amount={item.subtotal.price} />
          </div>
        </div>
      )}
    </div>
  );
};
